import {
  USER_LOGIN_REQUESTED,
  USER_LOGIN_SUCCESSFUL,
  USER_LOGIN_FAILED,
  USER_REGISTRATION_REQUESTED,
  USER_REGISTRATION_SUCCESSFUL,
  USER_REGISTRATION_FAILED,
  USER_FORGOT_PASSWORD_REQUESTED,
  USER_FORGOT_PASSWORD_SUCCESSFUL,
  USER_FORGOT_PASSWORD_FAILED,
  USER_RESET_PASSWORD_REQUESTED,
  USER_RESET_PASSWORD_SUCCESSFUL,
  USER_RESET_PASSWORD_FAILED,
  USER_LOGOUT_REQUESTED,
  USER_RESEND_EMAIL_REQUESTED,
  USER_RESEND_EMAIL_SUCCESSFUL,
  USER_RESEND_EMAIL_FAILED,
  USER_CHANGE_PASSWORD_REQUESTED,
  USER_CHANGE_PASSWORD_SUCCESSFUL,
  USER_CHANGE_PASSWORD_FAILED,
  SET_AUTH_ERROR,
  TOGGLE_AUTH_MODAL,
  UNTOGGLE_AUTH_MODAL,
  SIGN_IN_FACEBOOOK_REQUEST,
  SIGN_IN_FACEBOOOK_SUCCESS,
  SIGN_IN_FACEBOOOK_FAILED,
  SIGN_UP_FACEBOOOK_REQUEST,
  SIGN_UP_FACEBOOOK_SUCCESS,
  SIGN_UP_FACEBOOOK_FAILED,
  SIGN_IN_GOOGLE_REQUEST,
  SIGN_IN_GOOGLE_SUCCESS,
  SIGN_IN_GOOGLE_FAILED,
  SIGN_UP_GOOGLE_REQUEST,
  SIGN_UP_GOOGLE_SUCCESS,
  SIGN_UP_GOOGLE_FAILED,
  GET_TOKEN_PROFILE_REQUESTED,
  GET_TOKEN_PROFILE_SUCCESS,
  GET_TOKEN_PROFILE_FAILED,
  LOGIN_WALLET_ADDRESS_REQUESTED,
  LOGIN_WALLET_ADDRESS_SUCCESSFUL,
  LOGIN_WALLET_ADDRESS_FAILED,
} from "./action-types"

import { AUTH_SUCCESS, AUTH_TYPES } from "constants/auth-types"

const initialState = {
  isLoading: false,
  isAuthorized: localStorage.getItem("token") !== null,
  accessToken: localStorage.getItem("token") || "",
  userId: localStorage.getItem("userId"),
  studentId: localStorage.getItem("studentId"),
  role: localStorage.getItem("role"),
  userDetails: {},
  authModal: {
    isShowing: false,
    type: "",
    successType: "",
  },
  errors: {},
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUESTED:
    case USER_REGISTRATION_REQUESTED:
    case USER_FORGOT_PASSWORD_REQUESTED:
    case USER_RESET_PASSWORD_REQUESTED:
    case USER_RESEND_EMAIL_REQUESTED:
    case USER_CHANGE_PASSWORD_REQUESTED:
    case SIGN_IN_FACEBOOOK_REQUEST:
    case SIGN_UP_FACEBOOOK_REQUEST:
    case SIGN_IN_GOOGLE_REQUEST:
    case SIGN_UP_GOOGLE_REQUEST:
    case GET_TOKEN_PROFILE_REQUESTED:
    case LOGIN_WALLET_ADDRESS_REQUESTED:
      return {
        ...state,
        isLoading: true,
        errors: {},
      }

    case USER_LOGIN_SUCCESSFUL:
    case SIGN_IN_FACEBOOOK_SUCCESS:
    case SIGN_IN_GOOGLE_SUCCESS:
    case LOGIN_WALLET_ADDRESS_SUCCESSFUL:
      const {
        data: { token, student_id, id: user_id, role },
      } = action.payload
      return {
        ...state,
        isLoading: false,
        authModal: {
          isShowing: false,
          type: "",
          successType: "LOGIN",
        },
        isAuthorized: true,
        accessToken: token,
        userId: student_id || user_id,
        studentId: user_id,
        userDetails: action?.payload?.data,
        role: role,
      }
    case GET_TOKEN_PROFILE_SUCCESS:
      const {
        data: { id, student_id: studentId, role: userRole },
      } = action.payload
      return {
        ...state,
        isLoading: false,
        isAuthorized: true,
        userId: studentId || id,
        studentId: studentId,
        userDetails: action?.payload?.data,
        role: userRole,
      }
    case SIGN_IN_FACEBOOOK_FAILED:
    case SIGN_IN_GOOGLE_FAILED:
    case USER_LOGIN_FAILED:
    case GET_TOKEN_PROFILE_FAILED:
    case LOGIN_WALLET_ADDRESS_FAILED:
      return {
        ...state,
        isLoading: false,
        isAuthorized: false,
      }

    case USER_CHANGE_PASSWORD_SUCCESSFUL:
    case USER_FORGOT_PASSWORD_FAILED:
    case USER_RESET_PASSWORD_FAILED:
    case USER_CHANGE_PASSWORD_FAILED:
    case USER_REGISTRATION_FAILED:
    case SIGN_UP_FACEBOOOK_FAILED:
    case SIGN_UP_GOOGLE_FAILED:
      return {
        ...state,
        isLoading: false,
      }

    case SIGN_UP_FACEBOOOK_SUCCESS:
    case SIGN_UP_GOOGLE_SUCCESS:
      const {
        data: { student_id: student, id: user },
      } = action.payload
      return {
        ...state,
        isLoading: false,
        authModal: {
          isShowing: false,
          type: "",
          successType: "",
        },
        isAuthorized: true,
        userId: student || user,
        userDetails: action.payload.data,
        role: "ST",
      }
    case USER_REGISTRATION_SUCCESSFUL:
      const {
        data: { student_id: studentUserId, id: userId },
      } = action.payload
      return {
        ...state,
        isLoading: false,
        authModal: {
          isShowing: true,
          type: AUTH_TYPES.REGISTER,
          successType: AUTH_SUCCESS.REGISTER,
        },
        isAuthorized: true,
        userId: studentUserId || userId,
        userDetails: action.payload.data,
        role: "ST",
      }

    case USER_RESEND_EMAIL_SUCCESSFUL:
      return {
        ...state,
        isLoading: false,
      }

    case USER_RESEND_EMAIL_FAILED:
      let authModal = state.authModal
      return {
        ...state,
        isLoading: false,
        authModal: {
          ...authModal,
        },
      }

    case USER_FORGOT_PASSWORD_SUCCESSFUL:
      return {
        ...state,
        isLoading: false,
        authModal: {
          isShowing: true,
          type: AUTH_TYPES.FORGOT_PASSWORD,
          successType: AUTH_SUCCESS.FORGOT_PASSWORD,
        },
      }

    case USER_RESET_PASSWORD_SUCCESSFUL:
      return {
        ...state,
        isLoading: false,
        authModal: {
          isShowing: true,
          type: AUTH_TYPES.RESET_PASSWORD,
          successType: AUTH_SUCCESS.RESET_PASSWORD,
        },
      }

    case USER_LOGOUT_REQUESTED:
      return {
        ...state,
        isLoading: false,
        isAuthorized: false,
        accessToken: "",
        userId: "",
        userDetails: {},
        role: "",
        studentId: "",
      }

    case SET_AUTH_ERROR: {
      return {
        ...state,
        errors: action.payload,
      }
    }
    case TOGGLE_AUTH_MODAL:
      return {
        ...state,
        authModal: {
          isShowing: true,
          type: action.payload.type,
          successType: "",
        },
        errors: {},
      }
    case UNTOGGLE_AUTH_MODAL:
      return {
        ...state,
        authModal: {
          isShowing: false,
          type: "",
          successType: "",
        },
        errors: {},
      }

    default:
      return state
  }
}

export default authReducer
